import styled from 'styled-components';
import { Colors } from '@inplayer-org/inplayer-ui';

const SubheaderWithBorder = styled.header`
  border-bottom: 1px solid ${Colors.lightGray};
`;

export default SubheaderWithBorder;
